import { render, staticRenderFns } from "./OrdersTableRowDetails.vue?vue&type=template&id=3ef6978b&"
import script from "./OrdersTableRowDetails.vue?vue&type=script&lang=js&"
export * from "./OrdersTableRowDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports